import { useTranslation } from 'react-i18next'
import { UpIcon } from '../icons'

function Card({
    text,
    number,
    bgColor,
    icon,
    borderColor,
    compare,
    fullWidth
}: {
    fullWidth?: boolean
    compare: number
    text: string
    number: string
    bgColor: string
    icon: JSX.Element
    borderColor: string
}) {
    const { t } = useTranslation()

    return (
        <div className={` min-w-[180px] xxl:h-[150px] h-[100px] ${fullWidth && 'w-full'}`}>
            <div className={` h-full flex flex-col justify-between p-4 bg-[#F7F8FC] w-full xxl:w-full rounded text-[10px] text-[#8B98A3] border-l-[3px] ${fullWidth && 'w-full'} ${borderColor}`}>
                <div className="flex w-full justify-between">
                    <div>
                        <p className="text-[10px] xxl:text-[14px] font-semibold max-w-[90px] xxl:max-w-[120px]">{text}</p>
                        <p className="text-[18px] xxl:text-[24px] xxl:mt-4 font-semibold mt-2 text-[#51525F]">{number}</p>
                    </div>
                    <div className={`w-[29px] h-[29px] rounded-full flex items-center justify-center ${bgColor}`}>{icon}</div>
                </div>
                <div className="flex items-center  gap-[3px]">
                    <div className={`${compare < 0 ? 'rotate-180' : ''} mb-[2px]`}>
                        <UpIcon color={compare < 0 ? '#E20101' : '#0166FF'} />
                    </div>
                    <p className={`${compare < 0 ? 'text-[#E20101]' : 'text-[#0166FF]'} text-[10px] xxl:text-[14px]`}>{`${compare < 0 ? '' : '+'}${compare.toFixed(1)}`} </p>
                    <p className="text-[10px] xxl:text-[14px]">{t('appEnabled.previous_interval')}</p>
                </div>
            </div>
        </div>
    )
}

export default Card
